import Component from "./Loader";
import Label from "./components/Label";

interface ILoaderExtensions {
    Label: typeof Label;
}

export const Loader: typeof Component & ILoaderExtensions = Object.assign(
    Component,
    { Label },
);

export type { LoaderProps } from "./types";
